module.exports = __webpack_public_path__ + "img/g_Angelov.6def8fd2.jpg";